import { Component, HostListener, WritableSignal, ChangeDetectionStrategy } from '@angular/core'
import { TranslocoDirective } from '@jsverse/transloco'
import { ModalComponent } from './modal/modal.component'
import { ModalService } from '../../../services/modal.service'
import { BaseButtonComponent } from '../base/base-button/base-button.component'

export interface DefaultModalOptions {
	closable?: boolean;
	confirm?: boolean;
	confirmText?: string;
	cancel?: boolean;
	cancelText?: string;
}

export interface DefaultModalData {
	title: string;
	body: string;
	loading?: boolean;
	options?: DefaultModalOptions;
}

@Component({
	selector: 'default-modal',
	imports: [ModalComponent, TranslocoDirective, BaseButtonComponent],
	styles: '',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-modal *transloco="let t" [closable]="currentData?.options?.closable" (closed)="close()">
			<div modal-title>
				<h2>{{ currentData?.title }}</h2>
			</div>

			<div modal-body>
				<p>{{ currentData?.body }}</p>
			</div>

			<div modal-footer>
				@if (currentData?.options?.confirm) {
					<base-button variant="primary" [loading]="isLoading()" (click)="confirm()">
						{{ currentData.options.confirmText || t('actions.confirm') }}
					</base-button>
				}
				@if (currentData?.options?.cancel) {
					<base-button variant="secondary" [loading]="isLoading()" (click)="close()">
						{{ currentData.options.cancelText || t('actions.cancel') }}
					</base-button>
				}
			</div>
		</app-modal>
	`
})
export class DefaultModalComponent {
	@HostListener('document:keydown.enter')
	onEnterKey() {
		this.handleEnterKey()
	}

	public data: WritableSignal<DefaultModalData | null>
	public isLoading!: WritableSignal<boolean>

	constructor(public modalService: ModalService) {
		this.data = this.modalService.getData('default')
		this.isLoading = this.modalService.getLoading('default')
	}

	get currentData(): DefaultModalData | null {
		return this.data()
	}

	confirm() {
		if (this.data()?.options?.closable !== false) {
			this.modalService.close('default', true)
		}

		this.modalService.click('default', true)
	}

	close() {
		this.modalService.close('default', false)
		this.modalService.click('default', false)
	}

	private handleEnterKey() {
		if (this.data()?.options?.confirm) {
			this.confirm()
		}
	}
}
